import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HourlyProductUsage from './hourly-product-usage';
import HourlyProductUsageDetail from './hourly-product-usage-detail';
import HourlyProductUsageUpdate from './hourly-product-usage-update';
import HourlyProductUsageDeleteDialog from './hourly-product-usage-delete-dialog';

const HourlyProductUsageRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HourlyProductUsage />} />
    <Route path="new" element={<HourlyProductUsageUpdate />} />
    <Route path=":id">
      <Route index element={<HourlyProductUsageDetail />} />
      <Route path="edit" element={<HourlyProductUsageUpdate />} />
      <Route path="delete" element={<HourlyProductUsageDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HourlyProductUsageRoutes;
